import {AnswerState} from '@esgi/core/enums';

export class ChangeActivePanelEvent {
	constructor(public activePanel: AnswerState) {}
}

export class TestSubsetOpenEvent {}
